import { useApolloClient, useLazyQuery, useMutation } from "@apollo/client";
import { useCallback } from "react";
import {
  GET_ENTITY_IMAGE_UPLOAD_URL,
  DELETE_ENTITY_IMAGE,
} from "../graphql/mutation/EntityImage";

const useEntityImageUpload = ({ refetchQueries } = {}) => {
  const client = useApolloClient();
  const [getUploadUrl, { loading: uploadLoading }] = useLazyQuery(
    GET_ENTITY_IMAGE_UPLOAD_URL,
    { fetchPolicy: "network-only" },
  );
  const [deleteImage, { loading: deleteLoading }] =
    useMutation(DELETE_ENTITY_IMAGE);

  const refetch = useCallback(async () => {
    if (refetchQueries?.length) {
      await client.refetchQueries({ include: refetchQueries });
    }
  }, [client, refetchQueries]);

  const uploadEntityImage = useCallback(
    async ({ entityType, entityId, imageType, file }) => {
      const res = await getUploadUrl({
        variables: {
          input: { entityType, entityId, imageType },
        },
      });

      const { success, uploadUrl, error } =
        res?.data?.getEntityImageUploadUrl ?? {};

      if (!success || !uploadUrl) {
        return { success: false, error };
      }

      await fetch(uploadUrl, {
        method: "PUT",
        body: file,
      });

      await refetch();
      return { success: true };
    },
    [getUploadUrl, refetch],
  );

  const deleteEntityImage = useCallback(
    async ({ entityType, entityId, imageType }) => {
      const res = await deleteImage({
        variables: {
          input: { entityType, entityId, imageType },
        },
      });

      await refetch();
      return res?.data?.deleteEntityImage ?? { success: false };
    },
    [deleteImage, refetch],
  );

  return {
    uploadEntityImage,
    deleteEntityImage,
    loading: uploadLoading || deleteLoading,
  };
};

export default useEntityImageUpload;
